module.exports = __webpack_public_path__ + "img/thunder-move.6e0debb0.svg";